import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgSelectModule } from '@ng-select/ng-select';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { TypingAnimationDirective } from '@qwyk/ui-standalone';

import { LinebreaksPipe } from './pipes/linebreaks.pipe';
import { DecimalToDMSPipe } from './pipes/decimal-to-dms.pipe';
import { ObjectToDatePipe } from './pipes/object-to-date.pipe';

import { PartyAddressComponent } from './components/party-address/party-address.component';
import { LoadingIndicatorComponent } from './components/loading-indicator/loading-indicator.component';

@NgModule({
    declarations: [
        DecimalToDMSPipe,
        ObjectToDatePipe,
        LinebreaksPipe,
        LoadingIndicatorComponent,
        PartyAddressComponent,
    ],
    imports: [
        CommonModule,
        FontAwesomeModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        TypingAnimationDirective
    ],
    exports: [
        DecimalToDMSPipe,
        ObjectToDatePipe,
        LinebreaksPipe,
        LoadingIndicatorComponent,
        PartyAddressComponent,
    ],
})
export class SharedModule {}
